import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import './style.css';

const FullPageSpinner = (props) => {
    return (
        <>
            <section className="spinner">
                <Spinner animation="border" role="status"  className={props.themeSpinner !== undefined && props.themeSpinner !== null ? props.themeSpinner : null}/>
            </section>
            <div className="bg-mask" />
        </>
    )
}

export default FullPageSpinner;
